import React from 'react';
import { ArrowRight, Battery, Forklift, Train } from 'lucide-react';
import { Link } from 'react-router-dom';
import ProductShowcase from '../components/ProductShowcase';
import SEOHead from '../components/SEOHead';

const ProductsPage = () => {
  const productSections = [
    { name: 'Traction Battery', href: '/products/traction-battery', icon: Forklift, description: 'Industrial mobility solutions' },
    { name: 'Energy Storage', href: '/products/energy-storage', icon: Battery, description: 'Grid & backup power systems' },
    { name: 'Rail Systems', href: '/products/rail-systems', icon: Train, description: 'Railway traction solutions' },
  ];

  return (
    <div className="pt-20">
      <SEOHead 
        title="Industrial Battery Products India | Traction, ESS, Ground Power"
        description="Complete range of industrial batteries made in India. Traction batteries for forklifts, cranes. Energy storage systems for commercial, industrial. Ground power units for defence and airports. Multi-Ion technology."
        keywords="industrial battery products India, traction battery, ESS battery, ground power unit, forklift battery, crane battery, warehouse battery, defence battery, airport GPU battery, rail battery, electric vehicle battery India"
        canonicalPath="/products"
      />
      <section className="py-12 sm:py-20 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6">
              Industrial <span className="text-emerald-400">Battery Products</span>
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto">
              Multi-Ion battery solutions engineered for industrial applications in India. Traction, energy storage, ground power.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-16">
            {productSections.map((section) => {
              const Icon = section.icon;
              return (
                <Link
                  key={section.name}
                  to={section.href}
                  className="group p-8 bg-gray-800/50 rounded-2xl border border-gray-700 hover:border-emerald-500/50 hover:bg-emerald-500/5 transition-all duration-300"
                >
                  <div className="w-16 h-16 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-6 group-hover:bg-emerald-500/20 transition-colors">
                    <Icon className="w-8 h-8 text-emerald-400" />
                  </div>
                  <h3 className="text-white font-semibold text-xl mb-2 group-hover:text-emerald-400 transition-colors">{section.name}</h3>
                  <p className="text-gray-500 text-base mb-4">{section.description}</p>
                  <span className="text-emerald-400 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    View details <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
      <ProductShowcase />
    </div>
  );
};

export default ProductsPage;
